function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState, useRef, useCallback, useLayoutEffect } from 'react';
import { createPopper } from '@popperjs/core';
import isEqual from 'lodash.isequal';
import { useMounted } from '@adsk/alloy-react-helpers';
export default function usePopper(_ref) {
  var _ref$placement = _ref.placement,
      initialPlacement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      offsetProp = _ref.offset,
      _ref$preventOverflow = _ref.preventOverflow,
      preventOverflow = _ref$preventOverflow === void 0 ? true : _ref$preventOverflow,
      _ref$fixed = _ref.fixed,
      fixed = _ref$fixed === void 0 ? false : _ref$fixed,
      _ref$show = _ref.show,
      show = _ref$show === void 0 ? true : _ref$show,
      _ref$flip = _ref.flip,
      flip = _ref$flip === void 0 ? true : _ref$flip,
      _ref$eventsEnabled = _ref.eventsEnabled,
      eventsEnabled = _ref$eventsEnabled === void 0 ? true : _ref$eventsEnabled,
      targetElement = _ref.targetElement,
      overlayElement = _ref.overlayElement,
      arrowElement = _ref.arrowElement,
      layoutDependency = _ref.layoutDependency;
  var isMountedRef = useMounted();
  var popper = useRef(null);

  var _useState = useState(initialPlacement),
      _useState2 = _slicedToArray(_useState, 2),
      placement = _useState2[0],
      setPlacement = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      popoverStyles = _useState4[0],
      setPopoverStyles = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      arrowStyles = _useState6[0],
      setArrowStyles = _useState6[1];

  useLayoutEffect(function () {
    if (targetElement && overlayElement) {
      popper.current = createPopper(targetElement, overlayElement, {
        placement: initialPlacement,
        strategy: fixed ? 'fixed' : 'absolute',
        modifiers: [{
          name: 'eventListeners',
          enabled: eventsEnabled
        }, {
          name: 'applyStyles',
          enabled: false
        }, {
          name: 'flip',
          enabled: flip,
          options: {
            padding: 0
          }
        }, {
          name: 'computeStyles',
          options: {
            gpuAcceleration: false,
            adaptive: false
          }
        }, {
          name: 'offset',
          options: {
            offset: offsetProp
          }
        }, {
          name: 'preventOverflow',
          enabled: preventOverflow,
          options: {
            tetherOffset: function tetherOffset() {
              return (arrowElement === null || arrowElement === void 0 ? void 0 : arrowElement.clientWidth) || 0;
            }
          }
        }, {
          name: 'arrow',
          enabled: Boolean(arrowElement),
          options: {
            element: arrowElement
          }
        }, {
          name: 'updateState',
          phase: 'write',
          enabled: true,
          fn: function fn(_ref2) {
            var state = _ref2.state;

            if (isMountedRef.current) {
              setPlacement(state.placement);
              setPopoverStyles(function (current) {
                return isEqual(current, state.styles.popper) ? current : state.styles.popper;
              });
              setArrowStyles(function (current) {
                return isEqual(current, state.styles.arrow) ? current : state.styles.arrow;
              });
            }
          }
        }]
      });
    }

    return function () {
      if (popper.current) {
        popper.current.destroy();
        popper.current = null;
      }
    };
  }, [eventsEnabled, fixed, flip, show, preventOverflow, targetElement, overlayElement, arrowElement, initialPlacement, isMountedRef, offsetProp, layoutDependency]);
  var update = useCallback(function () {
    if (popper.current) {
      popper.current.forceUpdate();
      return true;
    }

    return false;
  }, []);
  useLayoutEffect(function () {
    var id = requestAnimationFrame(function () {
      if (show) update();
    });
    return function () {
      cancelAnimationFrame(id);
    };
  }, [show, update]);
  return {
    update: update,
    placement: placement,
    styles: {
      overlay: popoverStyles,
      arrow: arrowStyles
    }
  };
}
//# sourceMappingURL=usePopper.js.map